import { render } from "./HomePage.vue?vue&type=template&id=85729d8c&scoped=true"
import script from "./HomePage.vue?vue&type=script&scoped=true&lang=js"
export * from "./HomePage.vue?vue&type=script&scoped=true&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=85729d8c&lang=css"
import "./HomePage.vue?vue&type=style&index=1&id=85729d8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85729d8c"]])

export default __exports__